<!-- <div class="container-out" (click)="close()" *ngIf="isVisible == true"></div> -->

@if (isVisible == true) {
  <div class="container-modulo">
    <h5>Módulo atual</h5>
    <h4>{{this.actualModuleName}}</h4>
    <div class="initial-module">
      <form class="form" [formGroup]="model" (ngSubmit)="submit()">
        <span>Definir como módulo inicial</span>
        <div class="form-field-toggle">
          <mat-slide-toggle formControlName="isDefaultModule" (change)="changeDefaultModule($event)"></mat-slide-toggle>
        </div>
      </form>
      <p class="default-module">Módulo Inicial:
        @if (this.defaultModuleName) {
          <span>{{this.defaultModuleName}}</span>
        } @else {
          Nenhum
        }
      </p>
    </div>
    <div class="action">
      <div class="filters">
        <mat-form-field class="filters-form" appearance="outline">
          <mat-icon matPrefix class="icon-search">search</mat-icon>
          <mat-label>Pesquisar</mat-label>
          <input matInput #search type="text" id="searchText" name="searchText" [(ngModel)]="searchText" (keyup)="onKeySearch()">
        </mat-form-field>
      </div>
      @if (isLoading) {
        <app-loading-list></app-loading-list>
      }
      @if (filteredListModuleStruct != null && filteredListModuleStruct != undefined) {
        <ul>
          @for (item of filteredListModuleGroupStruct; track item) {
            <ngContainer>
              <p class="module-names">{{item.nameModuleGroup}}</p>
              @for (item2 of filteredListModuleStruct; track item2) {
                <ngContainer [ngClass]="{'disabled-module': !item2.isModulePermitted}">
                  @if (item2.idModuleGroup == item.idModuleGroup) {
                    <ngContainer>
                      @if (item2.isModulePermitted || this.isMaster) {
                        <li>
                          <a (click)="redirect(item2)">
                            <span>{{item2.nameModule}}</span>
                            <mat-icon class="chevron" aria-hidden="false" aria-label="Menu apps">chevron_right</mat-icon>
                          </a>
                        </li>
                      }
                    </ngContainer>
                  }
                </ngContainer>
              }
              <br>
              </ngContainer>
            }
          </ul>
        }
      </div>
    </div>
  }